// extracted by mini-css-extract-plugin
export default {"detail__section":"details_page_detail__section__b0A8b","detail__reviews_n_related":"details_page_detail__reviews_n_related__mDxMw"};